//page-top
$(function () {
	$(window).scroll(function () {
		var s = $(this).scrollTop();
		var win = $(window).width();
		var m = 1000;
		var p = 843;
		if (win < p) {
			$("#pagetop").show();
		} else if (s > m) {
			$("#pagetop").fadeIn('slow');
		} else if (s < m) {
			$("#pagetop").fadeOut('slow');
		}
	});
	$("#pagetop").click(function () {
		$('html,body').animate({
			scrollTop: 0
		}, 'slow');
		return false;
	});
});
	
APNG.ifNeeded().then(function () {
  var images = document.querySelectorAll(".apng-image");
  for (var i = 0; i < images.length; i++){ APNG.animateImage(images[i]); }
});
